import React from 'react';
import { Col, Input, Label } from 'reactstrap';
import { listRDV } from '../config/type';

type Props = {
  rdvs?: listRDV | null;
  selected: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  disabled?: boolean;
};

export default function RdvSelect({ rdvs, selected, onChange, disabled }: Props) {
  return (
    <Col xs={6} className='mt-3 mb-4'>
      <Label htmlFor="rdv">File Caricati</Label>
      <Input
        type="select"
        id="rdv"
        name="rdv"
        value={selected}
        onChange={onChange}
        disabled={disabled}
      >
        <option value="">{'Scegli...'}</option>
        {rdvs?.list?.map(opt => (
          <option key={opt.ID} value={opt.ID}>
            {opt.nome}
          </option>
        ))}
      </Input>
    </Col>
  );
}
